import { render } from "./VideoPlayerControlsPlay.vue?vue&type=template&id=6bbef24a"
import script from "./VideoPlayerControlsPlay.vue?vue&type=script&lang=js"
export * from "./VideoPlayerControlsPlay.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sxdube/Documents/code/vue-viewer-plugin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__